// Alias
import List from '../utilities/menu-list/index';

export default List;
